import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import firebase from "firebase/app";
import Pharmacy from "@/components/Pharmacy.vue";
import Login from "@/components/Login.vue";
import AccountIncomplete from "@/views/AccountIncomplete";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "Home", component: Home, meta: { auth: true } },
  { path: "/login", name: "Login", component: Login, meta: { guest: true } },
  {
    path: "/account-incomplete",
    name: "AccountIncomplete",
    component: AccountIncomplete,
    meta: { auth: true }
  },
  {
    path: "/pharmacy",
    name: "Pharmacy",
    component: Pharmacy,
    meta: { auth: true }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then(tokenResult => {
            const claims = tokenResult.claims;
            const finalized =
              !!claims.email_verified &&
              !!claims.pharmacy_set &&
              !!claims.account_approved;
            if (finalized) next();
            else next({ path: "/account-incomplete" });
          });
        next();
      } else next({ path: "/login" });
    });
  } else if (to.matched.some(record => record.meta.guest)) {
    firebase.auth().onAuthStateChanged(user => {
      if (user) next({ path: "/" });
      else next();
    });
  } else next();
});

export default router;
